import React from "react";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import { X } from "react-feather";
import { useEffect, useState } from "react";

import moment from "moment";
//sEmailAddress
export default function ConfirmHandholderAssignmentModal(props) {
	useEffect(() => {}, [props.isOpen]);

	const renderbulkAssignServiceRequest = () => {
		const temp = props.bulkAssignServiceRequest;

		if (Object.keys(props.bulkAssignServiceRequest).length > 0) {
			return Object.entries(temp).map(([key, value]) => {
				console.log("value", value);
				if (typeof value !== "object")
					return (
						<div style={{ padding: "10px" }}>
							<div
								style={{
									padding: "5px",
								}}
							>
								<span>
									Customer email : <b>{key}</b>
								</span>
								<span
									style={{
										float: "right",
									}}
								>
									Number of services : <b>0</b>
								</span>
							</div>

							<span>{value}</span>
						</div>
					);

				let x = value.map((e) => {
					return (
						<tr>
							<td style={{ width: "16%" }}>
								{e["nResourceInstanceId"]}
							</td>
							<td style={{ width: "16%" }}>
								{e["sServiceCode"]}
							</td>
							<td style={{ width: "16%" }}>
								{e["sEmailAddress"]}
							</td>
							<td style={{ width: "16%" }}>
								{e["sContactNumber"]}
							</td>

							<td style={{ width: "16%" }}>
								{moment(e["dtFollowupOn"]).format("DD/MM/YYYY")}
							</td>
							{props.useForSPM ? (
								<td style={{ width: "16%" }}>
									{e["refCurrentState"]["sServiceState"]}
								</td>
							) : (
								<td style={{ width: "16%" }}>
									{e["refSRState"]}
								</td>
							)}
						</tr>
					);
				});
				return (
					<>
						<div style={{ padding: "10px" }}>
							<div style={{ padding: "5px" }}>
								<span>
									Customer email :{" "}
									{props.useForSPM &&
									value[0]["customer_meta"] &&
									Object.keys(value[0]["customer_meta"])
										.length ? (
										<b>
											{value[0]["customer_meta"]["email"]}
										</b>
									) : (
										<b>{key}</b>
									)}
								</span>
								<span style={{ float: "right" }}>
									Number of services : <b>{value.length}</b>
								</span>
							</div>

							<table style={{ tableLayout: "fixed" }}>
								<tr>
									<th>Instance Id</th>

									<th>Service Name</th>
									<th>Email(SR)</th>

									<th>Phone Number(SR)</th>

									<th>Follow up</th>
									<th>Current State</th>
								</tr>
								{x}
							</table>
						</div>
					</>
				);
			});
		} else {
			return (
				<>
					<span
						style={{
							padding: "10px 10px",
							paddingInline: "10px",
							backgroundColor: "#eac1c1",
							display: "inline-block",
						}}
					>
						A handholder cannot be assigned to the service requests
						that you have selected. Please make sure that you have
						selected correct service requests
					</span>
				</>
			);
		}
	};
	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent>
				<div className="status-column">
					<div className="p-2 modal-header-bar">
						<span>Summary</span>
						<button
							type="button"
							className="close"
							aria-label="Close"
							onClick={props.toggleModal}
						>
							<X
								style={{ pointerEvents: "none" }}
								color="white"
							/>
						</button>
					</div>
					<div
						style={{
							padding: "20px",
							overflowY: "scroll",
							height: "400px",
						}}
					>
						<>
							<div
								style={{
									padding: "10px",
									display: "inline-block",
								}}
							>
								<span>
									Total number of services :{" "}
									<b>{props.numberOfServices}</b>
								</span>
							</div>
							<div>{renderbulkAssignServiceRequest()}</div>
						</>
					</div>
					<div style={{ padding: "10px" }}>
						{/* <Button onClick={props.handleHandholderAssigned}>Assign</Button>
            <span className="ml-2 cursor-pointer" onClick={props.toggleModal}>
              Cancel
            </span> */}
					</div>
				</div>
			</ModalContent>
		</Modal>
	);
}

/** */
